import { Button, Col } from "antd";
import styled from "styled-components";

export const ButtonContainer = styled(Col)`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5%;

  & * {
    width: 100%;
  }

  & .ant-form-item-control-input-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 768px) {
    margin-left: 15%;
  }
`;

export const ModalButtonYellow = styled(Button)`
  width: 100%;
  background-color: #fdd440;
  color: #1070b6;
  font-size: 24px;
  font-weight: bold;
  border: 0px;
  padding: 0px;

  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  & span {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    background-color: rgb(253, 212, 64, 0.8);
  }

  &:focus {
    background-color: #fdd440;
    color: #1070b6;
  }

  & > .ant-btn-loading-icon {
    width: 50px;
    margin-left: 5%;
  }

  &.ant-btn-loading {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const ModalButtonBlue = styled(ModalButtonYellow)`
  background-color: #d3e8ff;

  &:hover {
    background-color: #d3e8ff;
    filter: brightness(90%);
  }

  &:focus {
    background-color: #d3e8ff;
    color: #1070b6;
  }
`;
